import { useIsOwner } from '../state/AuthContext';

// Owner-only page links, right-aligned, no container chrome - just clickable
// text. Renders nothing for user (Jenny) or anonymous, so the other surfaces are
// invisible to a non-owner rather than merely blocked. Plain anchors, not client
// routing: /irp is a separate static app and /push /td /ref are path-routed
// reloads, so a real navigation is correct here.
const LINKS: { href: string; label: string }[] = [
  { href: '/', label: 'Dashboard' },
  { href: '/irp/', label: 'IRP' },
  { href: '/push', label: 'Push' },
  { href: '/td', label: 'To-do' },
  { href: '/ref', label: 'Ref' },
];

export function OwnerNav({ current }: { current?: string }) {
  if (!useIsOwner()) return null;

  const path = current ?? (typeof window !== 'undefined' ? window.location.pathname : '/');
  const isActive = (href: string) =>
    href === '/' ? path === '/' : path.startsWith(href.replace(/\/$/, ''));

  return (
    <nav aria-label="Owner navigation" style={{
      display: 'flex', justifyContent: 'flex-end', gap: 18, flexWrap: 'wrap',
      margin: '0 0 12px',
    }}>
      {LINKS.map(l => {
        const active = isActive(l.href);
        return (
          <a key={l.href} href={l.href} aria-current={active ? 'page' : undefined}
            style={{
              textDecoration: 'none',
              font: '13px/1 ui-monospace, monospace', letterSpacing: '0.03em',
              color: active ? '#eaf2fb' : '#8fb3d4',
              opacity: active ? 1 : 0.85,
            }}>
            {l.label}
          </a>
        );
      })}
    </nav>
  );
}
